import { theme, useResponsive } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";

import { useContentSchemaRenderIframe } from "~/components/content/content-schema-render/iframe/hooks";
import { onlyOnePlayingPlayerAtom } from "~/lib/only-one-playing-player";

type GetOnlyOnePlayingPlayerIframeExtraPropsParameters = {
  isArticleSpeechifyPlayerPlaying: boolean;
  isDesktopUp: boolean;
};

const getOnlyOnePlayingPlayerIframeExtraProps = ({
  isArticleSpeechifyPlayerPlaying,
  isDesktopUp,
}: GetOnlyOnePlayingPlayerIframeExtraPropsParameters) => {
  if (!isDesktopUp) {
    return {
      enableAutoPlay: false,
    };
  }

  return isArticleSpeechifyPlayerPlaying
    ? {
        enableAutoPlay: false,
      }
    : {
        enableAutoPlay: true,
      };
};

export const useOnlyOnePlayingPlayer = () => {
  const { isArticleSpeechifyPlayerPlaying } = useAtomValue(onlyOnePlayingPlayerAtom);

  const isDesktopUp = useResponsive(theme.breakpoints.up("desktop"));

  const { enableAutoPlay } = getOnlyOnePlayingPlayerIframeExtraProps({
    isArticleSpeechifyPlayerPlaying,
    isDesktopUp,
  });

  const { ComponentWithExtraPropsRenderFunction: OnlyOnePlayingPlayerIframeRenderFunction } =
    useContentSchemaRenderIframe({
      enableAutoPlay,
    });

  return {
    OnlyOnePlayingPlayerIframeRenderFunction,
  };
};
